import React, { useCallback } from 'react';

import { Space } from '@/components';
import { useFormVisible } from '@/hooks';
import { AnyTransactionPeriod, TransactionPeriod } from '@/model/wallets/types';
import { Func } from '@/utils/ts';

import { TransactionFilterCustomPeriodInput, TransactionFilterOptionSelection } from './components';

interface TransactionFilterOptionsSelectionProp {
  'data-test'?: string;
  value: AnyTransactionPeriod;
  onSelect: Func<[AnyTransactionPeriod]>;
}

const variants = [
  TransactionPeriod.lastWeek,
  TransactionPeriod.lastMonth,
  TransactionPeriod.last3Month,
  TransactionPeriod.custom,
];

const TransactionFilterOptionsSelection: React.FC<TransactionFilterOptionsSelectionProp> = ({
  value,
  onSelect,
  'data-test': dataTest,
}) => {
  const customFormControl = useFormVisible(false);
  const select = useCallback(
    (newPeriod: TransactionPeriod) => {
      if (newPeriod === TransactionPeriod.custom) {
        customFormControl.show();
      } else {
        onSelect({ type: newPeriod });
      }
    },
    [customFormControl, onSelect],
  );
  return customFormControl.visible ? (
    <TransactionFilterCustomPeriodInput
      data-test={dataTest && `${dataTest}-custom`}
      value={value.type === TransactionPeriod.custom ? value : undefined}
      onSelect={(v) => onSelect({ ...v, type: TransactionPeriod.custom })}
    />
  ) : (
    <Space direction="vertical" style={{ paddingLeft: 20, paddingRight: 20 }}>
      {variants.map((v) => (
        <TransactionFilterOptionSelection
          value={v}
          onSelect={select}
          key={v}
          isSelected={v === value.type}
          data-test={dataTest && `${dataTest}-type-${v}`}
        />
      ))}
    </Space>
  );
};

export default React.memo(TransactionFilterOptionsSelection);
